import * as React from "react";
const WaterTreatmentAndMiningSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="rgba(238, 65, 55, 1)"
      d="M6 22.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM6 24a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm12-1.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0 1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM.172 4.77A.75.75 0 0 1 .75 4.5h22.5a.75.75 0 0 1 .736.888l-2.25 12A.75.75 0 0 1 21 18H3a.75.75 0 0 1-.737-.612l-2.25-12a.75.75 0 0 1 .16-.618ZM1.652 6l1.97 10.5h16.755L22.347 6H1.653Z"
    />
    <path
      fill="rgba(238, 65, 55, 1)"
      fillRule="evenodd"
      d="M9 1.5a3.747 3.747 0 0 1 6 0c1.227 0 2.317.591 3 1.5 1.005 0 2.328.855 3 1.5h-3a1.51 1.51 0 0 1-1.2-.6A2.246 2.246 0 0 0 15 3a1.51 1.51 0 0 1-1.2-.6 2.245 2.245 0 0 0-3.6 0A1.51 1.51 0 0 1 9 3c-.76 0-1.433.376-1.842.957-.136.194-.29.375-.462.543H4.5c.195-.22.601-.648.843-.818a2.4 2.4 0 0 0 .59-.589A3.75 3.75 0 0 1 9 1.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default WaterTreatmentAndMiningSVG;
